module.exports = __webpack_public_path__ + "static/media/logoMobileHeader.4b8acbbc.svg";